export const parseApprovalResponse = (response) => {
  const body = response?.data ?? {};
  const pendingApproval =
    response?.status === 202 ||
    body?.status === 202 ||
    body?.approval_required === true;
  const approvalRequestId =
    body?.approval_request_id ?? body?.data?.approval_request_id ?? null;
  const message = body?.message ?? null;
  return {
    pendingApproval,
    approvalRequestId,
    message,
    data: body?.data ?? body,
  };
};

export const apiErrorMessage = (error, fallback = "Request failed.") =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  fallback;

/** Retry a gated action after approval using stored payload + approval_request_id */
export const ENTITY_APPLY_ENDPOINTS = {
  landlord_payout: {
    CREATE: { method: "post", path: "/admin/landlord_payments" },
  },
  rental_payment_custom: {
    CREATE: { method: "post", path: "/tenants/payments/custom" },
  },
  tenant_end_tenancy: {
    CREATE: { method: "post", path: "/landlords/rentals/units/remove" },
  },
  broker_payout: {
    UPDATE: { method: "post", path: "/admin/broker_payments/details/{id}" },
  },
};

const resolveRecordId = ({ entity_id, payload } = {}) =>
  entity_id ||
  payload?.id ||
  payload?.broker_payment_id ||
  payload?.payment_id ||
  null;

export const getEntityApplyUrl = (
  entityCode,
  action,
  baseUrl,
  adminBaseUrl,
  context = {}
) => {
  const endpoint = ENTITY_APPLY_ENDPOINTS[entityCode]?.[action];
  if (!endpoint) return null;

  let path = endpoint.path;
  if (path.includes("{id}")) {
    const recordId = resolveRecordId(context);
    if (!recordId) return null;
    path = path.replace("{id}", String(recordId));
  }

  if (path.startsWith("/admin/")) {
    return `${adminBaseUrl}${path.replace(/^\/admin/, "")}`;
  }
  return `${baseUrl}${path}`;
};

export const buildEntityApplyBody = (entityCode, action, payload, approvalRequestId) => {
  const body = { ...(payload ?? {}), approval_request_id: approvalRequestId };
  if (entityCode === "broker_payout" && action === "UPDATE" && !body.action) {
    body.action = "mark_paid";
  }
  return body;
};
